import React, { useState } from 'react';
import { generateVless, generateVmess, generateHapp } from '../utils/proxyGenerators';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInfo, FiGlobe, FiCpu, FiLink, FiAlertCircle } = FiIcons;

const CF_IPS = [
  { label: 'Cloudflare SJC', ip: '104.16.89.20' },
  { label: 'Cloudflare LAX', ip: '104.16.90.20' },
  { label: 'Cloudflare SEA', ip: '104.16.91.20' },
];

export default function ConfigForm({ onGenerate }) {
  const [protocol, setProtocol] = useState('sub');
  const [formData, setFormData] = useState({
    name: 'Nexus-Edge',
    uuid: 'd342d11e-d424-4583-b36e-524ab1f0afa4',
    address: CF_IPS[0].ip,
    port: '443',
    host: window.location.hostname,
    path: '/tunnel?ed=2048'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    let configStr = '';
    
    if (protocol === 'sub') {
      configStr = `https://${formData.host}/sub?uuid=${formData.uuid}`;
      onGenerate({ type: 'subscription', string: configStr, name: 'H-APP / Hiddify Subscription URL' });
      return;
    }

    if (protocol === 'vless') configStr = generateVless(formData);
    else if (protocol === 'vmess') configStr = generateVmess(formData);
    else if (protocol === 'hiddify') configStr = generateHapp(formData);
    
    onGenerate({ type: protocol, string: configStr, name: formData.name });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6 bg-gray-900/50 p-6 rounded-3xl border border-white/5 backdrop-blur-xl">
      <div className="flex bg-black/40 p-1.5 rounded-2xl border border-white/5 gap-1">
        {[
          { id: 'sub', label: 'Subscription' },
          { id: 'vless', label: 'VLESS' },
          { id: 'vmess', label: 'VMess' },
          { id: 'hiddify', label: 'Hiddify' }
        ].map(p => (
          <button
            key={p.id}
            type="button"
            onClick={() => setProtocol(p.id)}
            className={`flex-1 py-2.5 px-1 text-[9px] font-black rounded-xl transition-all uppercase tracking-tighter ${
              protocol === p.id ? 'bg-white text-black shadow-xl' : 'text-gray-500 hover:text-white'
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>

      <div className="space-y-4">
        {protocol === 'sub' ? (
          <div className="p-4 bg-blue-500/10 rounded-2xl border border-blue-500/20 space-y-3">
             <div className="flex items-center gap-2 text-blue-400">
               <SafeIcon icon={FiLink} size={18} />
               <span className="text-xs font-black uppercase tracking-widest">Subscription Mode</span>
             </div>
             <p className="text-[10px] text-gray-400 leading-relaxed">
               This generates a single <b>HTTPS URL</b>. In H-APP/Hiddify, go to <b>Subscriptions</b> &gt; <b>+</b> and paste this URL. It will automatically load all nodes.
             </p>
          </div>
        ) : (
          <div className="p-4 bg-amber-500/10 rounded-2xl border border-amber-500/20 space-y-2">
             <div className="flex items-center gap-2 text-amber-400">
               <SafeIcon icon={FiAlertCircle} size={18} />
               <span className="text-xs font-black uppercase tracking-widest">Single Node Mode</span>
             </div>
             <p className="text-[10px] text-gray-400 leading-relaxed">
               This generates a <b>Config String</b>. Do NOT paste this into the Subscription field. Instead, use <b>"Import from Clipboard"</b> in your proxy app.
             </p>
          </div>
        )}

        <div>
          <label className="text-[10px] text-gray-500 uppercase font-black flex items-center gap-1.5 mb-2 ml-1">
            <SafeIcon icon={FiGlobe} className="text-blue-400" />
            Cloudflare Pages Domain (SNI)
          </label>
          <input
            type="text"
            value={formData.host}
            onChange={(e) => setFormData({...formData, host: e.target.value})}
            className="w-full bg-black/60 border border-white/10 rounded-2xl p-4 text-sm text-blue-400 outline-none focus:border-blue-500/50 font-mono transition-colors"
          />
        </div>

        {protocol !== 'sub' && (
          <div>
            <label className="text-[10px] text-gray-500 uppercase font-black flex items-center gap-1.5 mb-2 ml-1">
              <SafeIcon icon={FiCpu} className="text-blue-400" />
              Connection IP (Clean IP)
            </label>
            <select
              value={formData.address}
              onChange={(e) => setFormData({...formData, address: e.target.value})}
              className="w-full bg-black/60 border border-white/10 rounded-2xl p-4 text-sm text-white outline-none focus:border-blue-500/50 appearance-none cursor-pointer"
            >
              {CF_IPS.map(ip => <option key={ip.ip} value={ip.ip}>{ip.label} ({ip.ip})</option>)}
              <option value={formData.host}>Direct (Use Domain)</option>
            </select>
          </div>
        )}
      </div>

      <button type="submit" className="w-full py-4.5 bg-gradient-to-br from-blue-500 to-indigo-600 hover:from-blue-400 hover:to-indigo-500 text-white font-black rounded-2xl transition-all shadow-lg shadow-blue-500/20 uppercase tracking-widest text-xs">
        {protocol === 'sub' ? 'Generate Subscription URL' : `Generate ${protocol} Config`}
      </button>
    </form>
  );
}